<template>
  <b-modal
    id="page-audio-modal"
    :ok-title="trans(block && block.id ? 'save' : 'create')"
    :cancel-title="trans('cancel')"
    size="xl"
    no-enforce-focus
    @shown="onShown"
    @ok="onSave"
  >
    <template v-slot:modal-title>
      <span>{{ trans('audio_file') }}</span>
      <small v-if="!!block" class="text-muted ml-2">
        #{{ block.id }}
      </small>
    </template>
    <b-row>
      <b-col class="col-12 col-md-6">
        <b-row>
          <b-col>
            <b-form-group>
              <b-form-file
                v-model="file"
                :disabled="busy"
                :placeholder="trans('upload_audio')"
                :drop-placeholder="trans('drop_file_here')"
                :browse-text="trans('browse')"
                accept="audio/mpeg', 'audio/mp3', 'audio/x-wav', 'audio/flac', 'audio/wav', 'audio/m4a', 'audio/x-m4a"
                @input="onAudioFileChange"
              />
            </b-form-group>
          </b-col>
          <b-col class="col-auto">
            <b-button :variant="show_media ? 'danger' : 'primary'" @click="show_media = !show_media">
              {{ trans(show_media ? 'cancel' : 'media') }}
            </b-button>
          </b-col>
        </b-row>
        <b-form-group>
          <html-textarea
            :organization="organization"
            v-model="text"
            for-microsite
            show-insert-form-document
            showHtmlMode
            @html="onHtmlMode($event)"
            :html_mode_value="html_mode_value"
          ></html-textarea>
        </b-form-group>
      </b-col>
      <b-col v-if="show_media" class="col-12 col-md-6">
        <audios-table
          :organization="organization"
          :per-page="3"
          hide-upload
          audio-name-only
          no-open
          @choose="onChooseAudio"
          class="mt-2"
        ></audios-table>
      </b-col>

      <b-col v-if="!show_media" class="col-12 col-md-6">
        <p class="lead text-center" v-if="busy">
          <i class="fa fa-fw fa-circle-notch fa-spin"></i>
          <span v-if="upload_percent === null">{{ trans('please_wait') }}</span>
          <span v-if="upload_percent !== null && upload_percent < 100">
            {{ trans('uploading') }}
            {{ upload_percent }}%
          </span>
          <span v-if="upload_percent == 100">
            {{ trans('generating_preview_thumbnail') }}
          </span>
        </p>
        <div v-if="!busy">
          <p class="mb-2">{{ trans('preview') }}</p>
          <b-card class="mb-4">
            <div v-html="text" class="mb-3"></div>
            <div class="mb-2 text-center">
              <audio
                :src="image_cta_url"
                controls
              />
            </div>
          </b-card>
        </div>
        
        <b-form-group :label="trans('width')">
          <b-form-radio-group v-model="image_percent" :options="image_percent_options" />
        </b-form-group>
        <b-form-group :label="trans('position')">
          <b-form-radio-group v-model="span_row">
            <b-form-radio :value="false">
              {{ trans('inline') }}
            </b-form-radio>
            <b-form-radio :value="true">
              {{ trans('span_row') }}
            </b-form-radio>
          </b-form-radio-group>
        </b-form-group>
        <b-form-group v-if="span_row" :label="trans('align')">
          <b-form-radio-group v-model="h_align" :options="h_align_options"></b-form-radio-group>
        </b-form-group>

      </b-col>
    </b-row>

    <p v-if="busy">
      <i class="fa fa-fw fa-circle-notch fa-spin"></i>
      {{ trans('please_wait') }}
    </p>
    <p v-if="error" class="text-danger">
      {{ error }}
    </p>
  </b-modal>
</template>

<script>
  import AudiosTable from '../media/AudiosTable'
  import HtmlTextarea from './../../../common/components/HtmlTextarea'

  export default {
    props: {
      organization: Object,
      page: Object,
      block: Object,
      after: Number,
    },
    components: {
      HtmlTextarea,
      AudiosTable,
    },
    data() {
      return {
        trans: trans,
        busy: false,
        error: null,
        tab: 0,
        file: null,
        show_media: false,
        text: trans('press_play'),
        html_mode_value: false,
        image_percent: 1.0,
        upload_percent: null,
        image_cta_url: null,
        image_percent_options: [
          {text: '25%', value: 0.25},
          {text: '33%', value: 0.3333},
          {text: '50%', value: 0.5},
          {text: '66%', value: 0.6666},
          {text: '75%', value: 0.75},
          {text: '100%', value: 1.0},
        ],
        span_row: true,
        h_align: 'center',
        h_align_options: [
          {value: 'left', text: trans('left')},
          {value: 'center', text: trans('center')},
          {value: 'right', text: trans('right')},
        ],
      }
    },
    computed: {
      serialized() {
        return {
          type: 'audio',
          text: this.text,
          after: this.after,
          image_percent: this.image_percent,
          meta: {
            html_mode: this.htmlModeValue,
          },
          span_row: this.span_row,
          h_align: this.h_align,
          image_cta_url: this.image_cta_url
        }
      },
    },
    methods: {
      onShown() {
        this.busy = false
        this.error = null
        this.text = this.block ? this.block.text : trans('press_play')
        this.htmlModeValue = this.block && this.block.meta && this.block.meta.html_mode
        this.image_percent = this.block ? this.block.image_percent : 1.0
        this.image_cta_url = this.block ? this.block.image_cta_url : null
        this.span_row = this.block ? this.block.span_row || false : false
        this.h_align = this.block ? this.block.h_align || 'center' : 'center'
      },
      onSave(e) {
        e.preventDefault()
        this.busy = true
        this.error = null
        let url = `/organization/${this.organization.id}/page/${this.page.id}/block`
        if (this.block && this.block.id) url += `/${this.block.id}`
        axios[this.block && this.block.id ? 'patch' : 'post'](url, this.serialized)
        .then(response => {
          this.busy = false
          this.$emit('saved', response.data)
          this.$bvModal.hide('page-audio-modal')
        })
        .catch(error => {
          this.busy = false
          this.error = _.errorFromAjax(error)
        })
      },
      onHtmlMode(value) {
        this.htmlModeValue = value
      },
      onAudioFileChange() {
        const url = `/organization/${this.organization.id}/media/audio`
        this.busy = true
        this.error = null
        this.show_media = false
        let formData = new FormData()
        formData.append("file", this.file)
        axios.post(url, formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          },
          onUploadProgress: e => {
            this.upload_percent = Math.round((e.loaded * 100) / e.total)
          },
        })
          .then(response => {
            this.upload_percent = 100
            setTimeout(() => {
              this.busy = false
              this.onChooseAudio(response.data)
              this.upload_percent = null
            }, 4000)
          })
        .catch(this.handleError)
      },
      onChooseAudio(audio_file) {
        this.alt = audio_file.name
        this.image_cta_url = audio_file.short_url
        this.show_media = false
      },
      handleError(error) {
      this.busy = false
      this.error = _.errorFromAjax(error)
      this.$bvToast.toast(this.error, {
        title: trans('error'),
        variant: 'danger',
        solid: true,
      })
    },
    },
    mounted() {
      window.pageAudioModal = this
    },
  }
</script>